import STOPWORDS from './stopwords.json';

type AcronymProps = {
  stopwords?: string[];
  formatter?: (letter: string) => string;
};

/**
 * Based loosely on @stdlib/string-acronym (https://www.npmjs.com/package/@stdlib/string-acronym)
 *
 * @example
 * Returns 'BA', because the built-in stopwords excludes 'of':
 * ```ts
 * acronym('Bank of America')
 * ```
 *
 * @example
 * Returns 'oA' because stopwords has been overridden:
 * ```ts
 * acronym('Bank of America', {
 *  stopwords: ['bank']
 * })
 * ```
 *
 * @example
 * disable all stopwords:
 * ```ts
 * acronym('Bank of America', {
 *  stopwords: []
 * }) > 'BoA'
 * ```
 *
 * @example
 * format each letter to return  'B!A!':
 * acronym('Bank of America', {
 *  formatter: (letter) => letter + '!'
 * })
 */
export default function acronym(str: string, opts?: AcronymProps) {
  const _stopwords = opts?.stopwords || STOPWORDS;

  return str
    .replace(/-/g, ' ')
    .split(' ')
    .filter(Boolean) // remove multiple spaces
    .filter((word) => !_stopwords.includes(word.toLocaleLowerCase()))
    .map((word) => {
      const letter = word.charAt(0);

      if (opts?.formatter) return opts.formatter(letter);

      return letter;
    })
    .join('');
}
